import { inject } from 'vue'
import { menuService } from 'services/menu.service'
import { storeToRefs } from 'pinia'
import { useMenuStore } from 'store/menu.store'
import useApiError from './useApiError'

export default function useMenu() {
  const { getMenu } = menuService()
  const { menu, loading, categorias } = storeToRefs(useMenuStore())
  const context = inject('context')

  async function initialRequests() {
    loading.value.menu = true
    try {
      const reqMenu = await getMenu(context?.assessment?.id)
      menu.value = reqMenu
    } catch (error) {
      useApiError(error)
    } finally {
      loading.value.menu = false
    }
  }

  return {
    initialRequests,
    menu,
    loading,
    categorias,
  }
}
